import { render } from "./OrderFooter.vue?vue&type=template&id=da46cfcc"
import script from "./OrderFooter.vue?vue&type=script&lang=js"
export * from "./OrderFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__